module.exports = __webpack_public_path__ + "media/assets/icons/validation-c5fbfc9dc797d8009b5ebcc0355a3b64.svg";